import React, { useMemo, useEffect, useState } from "react";
import {
  useTable,
  usePagination,
} from "react-table";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ContantLoader from "../../ContantLoader";
import CampaingRow from "./CampaingRow";

const CampaignTable = ({
  columns,
  data,
  fetchData,
  loading,
  currentTab,
  campaignStatusValue,
  searchText,
  viewReport,
  cloneCamp,
  editCampaign,
  archive,
  viewCampaign,
  toAudience,
  role,
  tab,
  companyLevelComplaiceFlag,
  pageCount: controlledPageCount,
}) => {

  const {
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
      manualPagination: true,
      pageCount: controlledPageCount,
    },
    usePagination
  );

  useEffect(() => {
    fetchData({ pageIndex, pageSize, currentTab, campaignStatusValue, searchText });
  }, [pageIndex, pageSize]);
  useEffect(() => {
    gotoPage(0)
    fetchData({ pageIndex, pageSize, currentTab, campaignStatusValue, searchText });
  }, [currentTab, campaignStatusValue, searchText])

  let campLabel = {
    fontSize: '14px',
    color: '#4f4f4f',
    fontWeight: 500,
    margin: 0,
    marginRight: '5px',
    width: '100px'
  }



  return (
    <>
      {loading ? (
        <ContantLoader />
      ) : (
        <div className="table-responsive" style={{ height: "auto" }}>

          {data && data.map((data, index) => {
            return <CampaingRow
              index={index}
              data={data}
              tab={tab}
              role={role}
              companyLevelComplaiceFlag={companyLevelComplaiceFlag}
              campLabel={campLabel}
              viewReport={viewReport}
              cloneCamp={cloneCamp}
              editCampaign={editCampaign}
              viewCampaign={viewCampaign}
              toAudience={toAudience}
              archive={archive}
            />
          })}

          {/* Pagination */}
          <div className="pagination">
            <select
              value={pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
              }}
            >
              {[10, 20, 30, 40, 50].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
            <button
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
              className="gotofirst"
            >
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    First Page
                  </Tooltip>
                )}
              >
                <i className="fa fa-angle-double-left"></i>
              </OverlayTrigger>
            </button>
            <button
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              className="gotoprevious"
            >
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    Previous
                  </Tooltip>
                )}
              >
                <i className="fa fa-angle-left"></i>
              </OverlayTrigger>
            </button>{" "}
            <button
              onClick={() => nextPage()}
              disabled={!canNextPage}
              className="gotonext"
            >
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    Next
                  </Tooltip>
                )}
              >
                <i className="fa fa-angle-right"></i>
              </OverlayTrigger>
            </button>{" "}
            <button
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
              className="gotolast"
            >
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    Last Page
                  </Tooltip>
                )}
              >
                <i className="fa fa-angle-double-right"></i>
              </OverlayTrigger>
            </button>{" "}
          </div>
        </div>
      )}
    </>
  );
};

export default CampaignTable;
